import React from 'react'; // eslint-disable-line
import { Link } from 'react-router-dom';
import constants from '../../constants';
import i18n from '../../i18n';

class ErrorItem extends React.Component {
    constructor(props) {
        super(props);
        this.getLink = this.getLink.bind(this);
    }

    getLink(link) {
        return `/projects/${this.props.projectId}/${link}`;
    }

    formatUrl(url) {
        // eslint-disable-next-line no-param-reassign
        url = url.replace('-', ' ');
        // eslint-disable-next-line no-param-reassign
        url = url.replace('/', ' > ');
        // eslint-disable-next-line no-param-reassign
        url = this.toTitleCase(url);

        return url;
    }

    // eslint-disable-next-line class-methods-use-this
    toTitleCase(str) {
        return str.replace(/\w\S*/g, (txt) => { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
    }

    render() {
        const { error } = this.props;
        const { id } = this.props;
        if (error.errorTypeString === 'MODS_ERR_NOMODULESENABLED' && this.props.pagesFlag) {
            error.errorMessage = 'One module or menu item must be enabled';
        }
        return (
            <div data-qa={`error-${error.errorTypeString}`} id={`error-${id}`} className="error-item">
                {constants.ConfigErrorCode.find((m) => { return m.ErrorCode === error.errorTypeString; }).Link !== '' && <div data-qa={`error-${id}-name`} id={`error-${id}-name`} className="error-item__name">{this.formatUrl(constants.ConfigErrorCode.find((m) => { return m.ErrorCode === error.errorTypeString; }).Link)}</div>}
                <div data-qa={`error-${id}-description`} id={`error-${id}-description`} className="error-item__description">{error.errorMessage}</div>
                {constants.ConfigErrorCode.find((m) => { return m.ErrorCode === error.errorTypeString; }).Link !== '' && <div data-qa={`error-${id}-button`} id={`error-${id}-button`} className="error-item__action"><Link to={this.getLink(constants.ConfigErrorCode.find((m) => { return m.ErrorCode === error.errorTypeString; }).Link)} className="btn btn-sq btn-sm btn-dark">{i18n.t('fix')}</Link></div>}
            </div>
        );
    }
}

export default ErrorItem;
